import { Fragment, useContext } from "react";
import CreditCard from "@components/CreditCard";
import Button from "@hudson/ui/components/FormFields/Button";
import useContent from "@lib/use_content";

interface SavedCardsProps {
  cards: be.TokenizedCreditCard[];
  onDelete: (id: string) => void;
}

function SavedCards({ cards = [], onDelete }: SavedCardsProps): JSX.Element | null {
  const { data, loading: queryLoading, error } = useContent(["bePaymentRemoveButton"]);

  if (cards.length == 0) return null;
  return (
    <div className="sm:grid sm:grid-cols-3 gap-x-4 gap-y-6 items-center">
      {cards.map((card, i) => (
        <Fragment key={i}>
          <CreditCard hideCvv={true} key={card?.uniqueId} tokenizedCard={card} />
          <div className="sm:col-span-2 mb-6 sm:mb-0 mt-2 sm:mt-0">
            <Button type="button" onClick={async () => onDelete(card)} asLink>
              {data?.content.bePaymentRemoveButton}
            </Button>
          </div>
        </Fragment>
      ))}
    </div>
  );
}

export default SavedCards;
